
export function checkAndRemoveCurrentDaySearchOption()
{
	if( $('#dateSelect').length > 0 ){
		var today = new Date();
		var todayString = buildStandardDateString( today );
		var dayOption = $('#dateSelect option:nth-child(2)');

		if( currentDayIsDisplayed(dayOption, todayString) === true )
		{
			var currentHour = today.getHours();
			var currentWeekDay = today.getDay();

			if( currentWeekDay === 6 && currentHour >= 12 )
			{
				var currentSelected = $('#dateSelect').val();
				if( currentSelected === todayString )
				{
					searchParameters.removeParameter('ankomst')
					$('#dateSelect').val('none');
				}
				$(dayOption).remove();
			}
		}
	}
}

function buildStandardDateString( date )
{
	var dd 			= date.getDate();
	var mm 			= date.getMonth()+1;
	var yyyy 		= date.getFullYear();
	if(dd<10){ dd='0'+dd; }
	if(mm<10){ mm='0'+mm; }
	var dateString 	= yyyy+'-'+mm+'-'+dd;

	return dateString;
}


function currentDayIsDisplayed( dayOption, dateString )
{
	var testingDate = $(dayOption).val();

	if(typeof testingDate !== 'undefined' && testingDate !== '' && testingDate !== 'none' )
	{
		if(testingDate === dateString)
		{
			return true;
		}
	}
	return false;
}
